export const LIST_ACTIVITIES = 'list_activities';
export const UPDATE_COMPANY = 'update_company';

export const VIEW_ADMIN_SECTION = 'view_admin_section';

export const CREATE_CODES = 'create_codes';
export const LIST_CODES = 'list_codes';
export const UPDATE_CODES = 'update_codes';
export const DELETE_CODES = 'delete_codes';

export const CREATE_ITEMS = 'create_items';
export const LIST_ITEMS = 'list_items';
export const UPDATE_ITEMS = 'update_items';
export const DELETE_ITEMS = 'delete_items';

export const CREATE_COMMENTS = 'create_comments';
export const LIST_COMMENTS = 'list_comments';
export const UPDATE_COMMENTS = 'update_comments';
export const DELETE_COMMENTS = 'delete_comments';

export const CREATE_DEPARTMENTS = 'create_departments';
export const LIST_DEPARTMENTS = 'list_departments';
export const UPDATE_DEPARTMENTS = 'update_departments';
export const DELETE_DEPARTMENTS = 'delete_departments';

export const CREATE_DOCUMENTS = 'create_documents';
export const LIST_DOCUMENTS = 'list_documents';
export const UPDATE_DOCUMENTS = 'update_documents';
export const DELETE_DOCUMENTS = 'delete_documents';

export const CREATE_EMAIL_TEMPLATES = 'create_email_templates';
export const LIST_EMAIL_TEMPLATES = 'list_email_templates';
export const UPDATE_EMAIL_TEMPLATES = 'update_email_templates';
export const DELETE_EMAIL_TEMPLATES = 'delete_email_templates';

export const CREATE_REQUIREMENT_TEMPLATES = 'create_requirement_templates';
export const LIST_REQUIREMENT_TEMPLATES = 'list_requirement_templates';
export const UPDATE_REQUIREMENT_TEMPLATES = 'update_requirement_templates';
export const DELETE_REQUIREMENT_TEMPLATES = 'delete_requirement_templates';

export const CREATE_REQUIREMENT_TEMPLATE_FOLDERS = 'create_requirement_template_folders';
export const LIST_REQUIREMENT_TEMPLATE_FOLDERS = 'list_requirement_template_folders';
export const UPDATE_REQUIREMENT_TEMPLATE_FOLDERS = 'update_requirement_template_folders';
export const DELETE_REQUIREMENT_TEMPLATE_FOLDERS = 'delete_requirement_template_folders';

export const CREATE_INSURANCE_POLICY_TYPES = 'create_insurance_policy_types';
export const LIST_INSURANCE_POLICY_TYPES = 'list_insurance_policy_types';
export const UPDATE_INSURANCE_POLICY_TYPES = 'update_insurance_policy_types';
export const DELETE_INSURANCE_POLICY_TYPES = 'delete_insurance_policy_types';

export const CREATE_INSURANCE_DOCUMENT_TYPES = 'create_insurance_document_types';
export const LIST_INSURANCE_DOCUMENT_TYPES = 'list_insurance_document_types';
export const UPDATE_INSURANCE_DOCUMENT_TYPES = 'update_insurance_document_types';
export const DELETE_INSURANCE_DOCUMENT_TYPES = 'delete_insurance_document_types';

export const CREATE_INSURANCE_LANGUAGES = 'create_insurance_languages';
export const LIST_INSURANCE_LANGUAGES = 'list_insurance_languages';
export const UPDATE_INSURANCE_LANGUAGES = 'update_insurance_languages';
export const DELETE_INSURANCE_LANGUAGES = 'delete_insurance_languages';

export const SEND_EMAILS = 'send_emails';
export const LIST_EMAILS = 'list_emails';
export const UPDATE_EMAILS = 'update_emails';
export const DELETE_EMAILS = 'delete_emails';

export const CREATE_JOBS = 'create_jobs';
export const LIST_JOBS = 'list_jobs';
export const UPDATE_JOBS = 'update_jobs';
export const DELETE_JOBS = 'delete_jobs';

export const CREATE_ITEM_CODE_STATUS_INQUIRING = 'create_item_code_status_inquiring';
export const CREATE_ITEM_CODE_STATUS_SUGGESTED = 'create_item_code_status_suggested';
export const CREATE_ITEM_CODE_STATUS_APPLIED = 'create_item_code_status_applied';
export const CREATE_ITEM_CODE_STATUS_WAIVED = 'create_item_code_status_waived';
export const CREATE_ITEM_CODE_STATUS_DEFAULT = 'create_item_code_status_default';
export const CREATE_ITEM_CODE_STATUS_REMOVAL_SUGGESTED = 'create_item_code_status_removal_suggested';

export const CREATE_POLICIES = 'create_policies';
export const LIST_POLICIES = 'list_policies';
export const DELETE_POLICIES = 'delete_policies';
export const CREATE_CUSTOM_DATES = 'create_custom_dates';
export const UPDATE_POLICIES = 'update_policies';
export const REMOVE_RECORD_AGENT = 'remove_record_agent';
export const ASSIGN_RECORD_WATCHERS = 'assign_record_watchers';

export const LIST_REQUIREMENTS = 'list_requirements';
export const CREATE_REQUIREMENTS = 'create_requirements';

export const CREATE_INSUREDS = 'create_insureds';
export const LIST_INSUREDS = 'list_insureds';
export const UPDATE_INSUREDS = 'update_insureds';
export const DELETE_INSUREDS = 'delete_insureds';
export const SEND_INSURED_EMAILS = 'send_insured_emails';

export const CREATE_USERS = 'create_users';
export const LIST_USERS = 'list_users';
export const UPDATE_USERS = 'update_users';
export const UPDATE_USER_ROLES = 'update_user_roles';

export const CREATE_INTEGRATIONS = 'create_integrations';
export const LIST_INTEGRATIONS = 'list_integrations';
export const UPDATE_INTEGRATIONS = 'update_integrations';
export const DELETE_INTEGRATIONS = 'delete_integrations';

export const CREATE_INSURANCE_COMPANIES = 'CREATE_INSURANCE_COMPANIES';
export const LIST_INSURANCE_COMPANIES = 'LIST_INSURANCE_COMPANIES';
export const UPDATE_INSURANCE_COMPANIES = 'UPDATE_INSURANCE_COMPANIES';
export const DELETE_INSURANCE_COMPANIES = 'DELETE_INSURANCE_COMPANIES';

/* EFM specific
================================================== */
export const COLLECTIONS = 'collections';
export const GET_REPORTS = 'get_reports';
export const GET_EMPLOYEES = 'get_employees';
